import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./category.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";

const addCategoryEndPoints = ApiEndpoints.category.categoryCreate;
export default function AddCategory() {
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const handleChange = useCallback(
    (e) => {
      setName(e.target.value)
    }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const payload = { name, };
      try {
        const response = await ApiRequest("POST", addCategoryEndPoints, payload);
        if (response.error === true) {
          toast.error(response.message)
        } else {
          toast.success(response.message)
          navigate("/admin/category");
        }

      } catch (error) {
        console.error("There was an error creating the Category!", error);
        toast.error(error);
      }
    }, [navigate, name]);

  return (
    <>
      <div className="header-add-category">
        <h5>Add Category</h5>
      </div>
      <div className="add-category-content">
        <form onSubmit={handleSubmit}>
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={handleChange}
            required
            className="form-control"
          />
          <div className="submit-formbtn">
            <button type="submit" className="default-btn">
              submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
